export class SC_PaginationState {
    private page: number | null;
    private size: number | null;

    constructor({ page = null, size = null } = {}) {
        this.page = page;
        this.size = size;
    }

    clone(): SC_PaginationState {
        return new SC_PaginationState({
            page: this.page,
            size: this.size
        });
    }

    merge(other: SC_PaginationState): SC_PaginationState {
        if (other.page !== null) this.page = other.page;
        if (other.size !== null) this.size = other.size;

        return this;
    }

    static fromURL(params: URLSearchParams): SC_PaginationState {
        let out = new SC_PaginationState();

        if (params.has("search_page"))
            out.page = Number(params.get("search_page"));
        else
            out.page = 0;

        if (params.has("size"))
            out.size = Number(params.get("size"));
        else
            out.size = 20;

        return out;
    }

    toURL(params: URLSearchParams): URLSearchParams {
        // Remove null values first
        if (this.page === null)
            params.delete("search_page");
        else
            params.set("search_page", this.page.toString());

        if (this.size === null)
            params.delete("size");
        else
            params.set("size", this.size.toString());

        return params;
    }

    applyToFormData(formData: FormData): void {
        if (this.page)
            formData.append('page', this.page.toString());
        if (this.size)
            formData.append('size', this.size.toString());
    }

    toSlice(): [number, number] {
        return [this.page * this.size, (this.page + 1) * this.size];
    }

    static basicEmpty() {
        return new SC_PaginationState({page: 0, size: 20});
    }
}
